<template>
    <div class="flex items-center">
        <div class="flex-grow">Viewing {{ from }} - {{ to }} of {{ total }}</div>
        <div class="text-right">
            <button
                :disabled="isPrevDisabled()"
                :class="hasPrevPage() ? 'text-grey-darker' : 'text-grey'"
                class="btn btn-xs mr-3"
                @click.prevent="prevPage()"
            >
                Prev
            </button>
            <button
                :disabled="isNextDisabled()"
                :class="hasNextPage() ? 'text-grey-daker' : 'text-grey'"
                class="btn btn-xs"
                @click.prevent="nextPage()"
            >
                Next
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'page',
            event: 'update'
        },
        props: {
            page: {
                type: Number,
                required: true
            },
            perPage: {
                type: Number,
                required: true
            },
            from: {
                type: Number,
                required: true
            },
            to: {
                type: Number,
                required: true
            },
            lastPage: {
                type: Number,
                required: true
            },
            count: {
                type: Number,
                required: true
            },
            total: {
                type: Number,
                required: true
            },
            isDisabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            prevPage () {
                if (this.isPrevDisabled()) return

                this.$emit('update', this.page - 1)
            },
            nextPage () {
                if (this.isNextDisabled()) return

                this.$emit('update', this.page + 1)
            },
            hasPrevPage () {
                return this.page > 1
            },
            hasNextPage () {
                return this.page < this.lastPage
            },
            isPrevDisabled () {
                return this.isDisabled || !this.hasPrevPage()
            },
            isNextDisabled () {
                return this.isDisabled || !this.hasNextPage()
            }
        }
    }
</script>
